function openLoading () {
  if (window.patpatE$1) {
    window.patpatE$1.emit('pat-loading:open')
  }
}
function closeLoading () {
  if (window.patpatE$1) {
    window.patpatE$1.emit('pat-loading:close')
  }
}

const sortTypeKey = 'sortType'
class ProductReview {

  apiHost = window.__patpatapi || 'https://shopify-api.patpat.com/'

  dom = null

  totalAll = 0

  productId = ''

  pagegroup = 5

  pageCount = 20

  currentPage = 1

  totalCount = 0

  currentTotal = 0

  imageCount = 0

  filterResult = {}

  currentLightbox = null

  filters = null

  reviewList = []

  reviewDateFormatter = null

  reviewDateFormatterLocale = ''

  avgRating = 5

  sizePercent = []

  langs = {
    en: {
      reviews: "Reviews",
      review: "Review",
      parents_talk: 'PARENTS TALK',
      what_parents_keep_telling_us: 'What parents keep telling us',
      verified_buyer: 'Verified Buyer',
      recommend_this_product: 'I recommend this product',
      hour_ago: '{count} hour ago',
      hours_ago: '{count} hours ago',
      day_ago: '{count} day ago',
      days_ago: '{count} days ago',
      week_ago: '{count} week ago',
      weeks_ago: '{count} weeks ago',
      month_ago: '{count} month ago',
      months_ago: '{count} months ago',
      total_pages: 'Total {page} Pages',
      all_reviews: 'All Reviews',
      images: 'Images',
      sort_by: 'Sort by',
      all: 'All',
      filter: 'Filter',
      sort: 'Sort',
      reset: 'Reset',
      apply: 'Apply',
    },
    de: {
      reviews: "Bewertungen",
      review: "Rezension",
      parents_talk: 'ELTERN ERZÄHLEN',
      what_parents_keep_telling_us: 'Was Eltern uns immer wieder sagen',
      verified_buyer: 'Geprüfter Käufer',
      recommend_this_product: 'Ich empfehle dieses Produkt',
      hour_ago: 'vor {count} Stunde',
      hours_ago: 'vor {count} Stunden',
      day_ago: 'vor {count} Tag',
      days_ago: 'vor {count} Tagen',
      week_ago: 'vor {count} Woche',
      weeks_ago: 'vor {count} Wochen',
      month_ago: 'vor {count} Monat',
      months_ago: 'vor {count} Monaten',
      total_pages: 'Insgesamt {page} Seiten',
      all_reviews: 'Kundenmeinungen',
      images: 'Bilder',
      sort_by: 'Sortieren nach',
      all: 'ALLE',
      filter: 'Filter',
      sort: 'Sortieren',
      reset: 'Zurücksetzen',
      apply: 'Anwenden',
    },
    es: {
      reviews: "Comentarios",
      review: "Revisar",
      parents_talk: 'LOS PADRES OPINAN',
      what_parents_keep_telling_us: 'Lo que los padres nos siguen contando',
      verified_buyer: 'Compr. Verificado',
      recommend_this_product: 'Recomiendo este producto',
      hour_ago: 'hace {count} hora',
      hours_ago: 'hace {count} horas',
      day_ago: 'hace {count} día',
      days_ago: 'hace {count} días',
      week_ago: 'hace {count} semana',
      weeks_ago: 'hace {count} semanas',
      month_ago: 'hace {count} mes',
      months_ago: 'hace {count} meses',
      total_pages: 'Total {page} paginas',
      all_reviews: 'Todos los comentarios',
      images: 'Imágenes',
      sort_by: 'Ordenar por',
      all: 'TODO',
      filter: 'Filtrar',
      sort: 'Ordenar',
      reset: 'Restablecer',
      apply: 'Aplicar',
    },
    fr: {
      reviews: "Commentaires",
      review: "Revoir",
      parents_talk: 'LES PARENTS EN PARLENT',
      what_parents_keep_telling_us: 'Ce que les parents nous disent sans cesse',
      verified_buyer: 'Acheteur Vérifié',
      recommend_this_product: 'Je recommande ce produit',
      hour_ago: 'il y a {count} heure',
      hours_ago: 'il y a {count} heures',
      day_ago: 'il y a {count} jour',
      days_ago: 'il y a {count} jours',
      week_ago: 'il y a {count} semaine',
      weeks_ago: 'il y a {count} semaines',
      month_ago: 'il y a {count} mois',
      months_ago: 'il y a {count} mois',
      total_pages: 'Total {page} pages',
      all_reviews: 'Tous les commentaire',
      images: 'Images',
      sort_by: 'Trier par',
      all: 'TOUS',
      filter: 'Filtre',
      sort: 'Trier',
      reset: 'Réinitialiser',
      apply: 'Appliquer',
    },
    pt: {
      reviews: "Comentários",
      verified_buyer: 'Comp. Verificado',
      recommend_this_product: 'Recomendo este produto',
      hour_ago: 'há {count} hora',
      hours_ago: 'há {count} horas',
      day_ago: 'há {count} dia',
      days_ago: 'há {count} dias',
      week_ago: 'há {count} semana',
      weeks_ago: 'há {count} semanas',
      month_ago: 'há {count} mês',
      months_ago: 'há {count} meses',
      total_pages: 'Total de {page} páginas',
      all_reviews: 'Todos os comentários',
      images: 'Imagens',
      sort_by: 'Ordenar por',
      all: 'TUDO',
      filter: 'Filtro',
      sort: 'Ordenar por',
      reset: 'Redefinir',
      apply: 'Aplicar',
    }
  }

  constructor ({
    el
  }) {
    this.dom = document.querySelector(el)
    if (this.dom) {
      const productId = this.dom.getAttribute('data-review-product-id')
      if (productId) {
        this.productId = productId
        this.init()
      }
    }
  }
  // 初始化 请求数据
  init () {
    // fetch(`/api/review/${this.productId}`).then(res => res.json()).then(res => {
    //   render(res)
    // })
    Promise.all([this.fetchReviewList(), this.fetchReviewInfo()]).then(async ([reviewRes, aggregate]) => {
      // console.log(reviewRes, filters, '---', window.patpatE$1)
      if (reviewRes && reviewRes.total > 0) {
        this.totalAll = aggregate ? aggregate.total : reviewRes.total
        this.totalCount = reviewRes.total
        this.currentTotal = reviewRes.total
        this.imageCount = reviewRes.withMediasTotal
        // this.filters = filters
        this.reviewList = reviewRes.productReviewVOList
        const avgRating = aggregate ? aggregate.avgRating : 5
        this.avgRating = Math.round(avgRating * 10) / 10
        this.sizePercent = aggregate ? aggregate.sizeEvaluationPercentVOList || [] : []
        this.updataProductInfoReview()
      }
      let empty = 'empty'
      // try {
      //   if (reviewRes) {
      //     if (reviewRes.total > 0) {
      //       empty = 'total > 0'
      //     } else {
      //       empty = 'total = 0'
      //     }
      //   } else {
      //     empty = 'not-reviewRes'
      //   }
      // } catch (error) {
      //   empty = 'error:-' + error.message
      // }
      handleProductStructDataString(this.reviewList || [], this.avgRating.toFixed(1), this.totalCount, empty)
      this.render()
    })
  }

  updataProductInfoReview () {
    const currentProductEls = document.querySelectorAll(`[data-product-id="${this.productId}"]`)
    
    const initProductInfoReviewEvent = (currentProductEl) => {
      const detailReviewWrap = currentProductEl.querySelector('[data-detail-review-wrap]')
      if (detailReviewWrap) {
        detailReviewWrap.addEventListener('click', () => {
          if (this.dom) {
            const currentScrollTop = document.body.scrollTop || document.documentElement.scrollTop
            const reviewElLayoutRefTop = this.dom.getBoundingClientRect().top
            document.documentElement.scrollTo({ top: reviewElLayoutRefTop + currentScrollTop, left: 0, behavior: 'smooth' });
          }
        })
        const starEl = detailReviewWrap.querySelector('[data-detail-review-star]')
        const starCountEl = detailReviewWrap.querySelector('[data-detail-review-count]')
        if (starEl) {
          starEl.style.width = this.avgRating * 20 + '%'
        }
        if (starCountEl) {
          starCountEl.innerHTML = this.totalAll
        }
        detailReviewWrap.classList.add('show')
      }
       
    }
    currentProductEls.forEach(currentProductEl => {
      initProductInfoReviewEvent(currentProductEl)
    })
  }

  throttle(func, delay = 500) {
    let timeoutId;
    return function(...args) {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
      timeoutId = setTimeout(() => {
        func.apply(this, args);
        timeoutId = null;
      }, delay);
    };
  }
  replaceTemplate(str, data) {
    // 如果 data 不存在，直接返回原字符串或全部替换为默认值
    if (data == null) {
      return str;
    }
    return str.replace(/\{\s*([^{}]+?)\s*\}/g, (match, key) => {
      const trimmedKey = key.trim();
      // 支持嵌套对象（如 user.name）
      const value = trimmedKey.split('.').reduce((obj, k) => obj?.[k], data);
      if (value !== undefined) return value;
      return '';
    });
  }
  $t(str, obj) {
    const strArr = str.split('.')
    let value = ''
    let enValue = strArr.reduce((obj, key) => {
      if (obj && obj[key]) {
        return obj[key]
      } else {
        return str
      }
    }, this.langs.en)
    if (this.langs[Shopify.locale]) {
      value = strArr.reduce((obj, key) => {
        if (obj && obj[key]) {
          return obj[key]
        } else {
          return enValue
        }
      }, this.langs[Shopify.locale])
    } else {
      value = enValue
    }
    const newValue = this.replaceTemplate(value, obj)
    return newValue
  }
  toUrlData (url, obj) {
    const str = (new URLSearchParams(obj || {})).toString()
    const s = url.indexOf('?') > -1 ? '&' : "?"
    url += s + str
    return url
  }

  async get (url, params = {}) {
    try {
      const host = this.apiHost
      // const host = window.__patpatapi
      const requestUrl = this.toUrlData(`${host}` + url, params)
      const isPc = window.innerWidth > 767;
      const uuid = g_getCookie && g_getCookie('pp105ut')
      const resStr = await fetch(requestUrl, {
        headers: {
          'Content-Type': 'application/json',
          'unique-session-id': uuid || '',
          'patpat-platform': isPc ? 'web' : 'wap',
          'pp-country': window.Shopify.country,
          'pp-language': (window.Shopify.locale || '').toLocaleUpperCase()
        }
      })
      const res = await resStr.json()
      if (res.code === 200) {
        return res.data || null
      } else {
        return Promise.reject({
          code: res.code,
          message: res.message
        })
      }
    } catch (err) {
      return Promise.reject(err)
    }
  }
  async fetchReviewInfo () {
    try {
      const params = {
        shopifyProductId: this.productId,
      }
      const aggregate = await this.get('/v1/product/review/aggregate', params)
      return aggregate
    } catch (err) {
      console.log(err)
      return null
    }
  }

  async fetchReviewFilter () {
    try {
      const params = {
        shopifyProductId: this.productId,
      }
      const filterData = await this.get('/v1/product/review/filter', params)
      return filterData
    } catch (err) {
      console.log(err)
      return null
    }
  }
  async fetchReviewList (reg = {}) {
    try {
      const params = {
        shopifyProductId: this.productId,
        pageSize: this.pageCount,
        page: this.currentPage,
        ...reg
      }
      const data = await this.get('/v1/product/review/list', params)
      return data
    } catch (err) {
      console.log(err)
      return null
    }
  }

  reviewCountFormat (value) {
    if (!Number(value)) {
      return value
    }
    if (+value < 100) {
      return value
    }
    if (+value < 1000) {
      return Math.floor(value / 10) * 10 + (value % 10 && '+') + ''
    }
    return Math.floor(value / 100) / 10 + 'k' + (value % 100 > 0 ? '+' : '') + ''
  }

  reviewTimeFormat (review) {
    if (!review.reviewedAt) {
      return ''
    }
    const reviewedAt = new Date(review.reviewedAt)
    if (Number.isNaN(reviewedAt.getTime())) {
      return review.reviewedAt
    }
    const localeMap = {
      de: 'de-DE',
      es: 'es-ES',
      fr: 'fr-FR',
      en: 'en-US'
    }
    const formatterLocale = localeMap[Shopify.locale] || 'en-US'
    if (!this.reviewDateFormatter || this.reviewDateFormatterLocale !== formatterLocale) {
      this.reviewDateFormatterLocale = formatterLocale
      this.reviewDateFormatter = new Intl.DateTimeFormat(
        formatterLocale,
        {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
        }
      )
    }
    return this.reviewDateFormatter.format(reviewedAt)
    // if (review.reviewedAt) {
    //   const createdAt = new Date(review.reviewedAt)
    //   const now = new Date()
    //   const diffHours = Math.floor((now - createdAt) / (1000 * 60 * 60))
    //   const diffDays = Math.floor(diffHours / 24)
    //   const diffWeeks = Math.floor(diffDays / 7)
    //   const diffMonths = Math.floor(diffDays / 30)
    //   if (diffHours < 24) {
    //     // return diffHours === 1 ? this.$t('hour_ago', { count: diffHours }) : this.$t('hours_ago', { count: diffHours })
    //     return diffHours <= 1 ? this.$t('hour_ago', { count: diffHours || 1 }) : this.$t('hours_ago', { count: diffHours })
    //   } else if (diffDays < 7) {
    //     return diffDays === 1 ? this.$t('day_ago', { count: diffDays }) : this.$t('days_ago', { count: diffDays })
    //   } else if (diffDays < 30) {
    //     return diffWeeks === 1 ? this.$t('week_ago', { count: diffWeeks }) : this.$t('weeks_ago', { count: diffWeeks })
    //   } else if (diffMonths < 8) {
    //     return diffMonths === 1 ? this.$t('month_ago', { count: diffMonths }) : this.$t('months_ago', { count: diffMonths })
    //   } else {
    //     return this.$t('months_ago', { count: 8 })
    //   }
    // }
    // return ''
  }

  renderImg (src, className = '', size = '250x0', alt = '', attr = '') {
    return `<img class="lazy-load-bg ${className}" ${attr} src="${src}" onload="javascript: this.classList.remove('lazy-load-bg')" loading="lazy" alt="${alt}"  /> `
  }

  renderReviewStar (percent, iconWidth = 24) {
    return `<span class="review-start-container" style="--start-icon-width:${iconWidth}px"><span class="review-start-value" style="width:${percent * 20}%"></span></span>`
  }

  renderReviewPercent(sizePercent) {
    if (sizePercent.length == 0) {return '';}
    const titleContent = sizePercent.reduce((str, value) => {
      return str + `
      <span aria-label="${value.sizeEvaluation + value.percent}%"
      >${value.sizeEvaluation}</span>
      `
    }, '')
    const barContent = sizePercent.reduce((str, value) => {
      return str + `
      <div class="percent-bar-item">
        <span class="percent-bar-item-line" >
          <i style="width: ${value.percent}%;"></i>
        </span>
      </div>
      `
    }, '')

    const valueContent = sizePercent.reduce((str, value) => {
      return str + `
      <span>${value.percent}%</span>
      `
    }, '')
    return `
      <div class="percent-title">${titleContent}</div>
      <div class="percent-bar">${barContent}</div>
      <div class="percent-value">${valueContent}</div>
    `
  }
  
  renderHeader (starLevel, sizePercent = [], allCount) {
    // if (this.dom.querySelector('[review-header]'))
    // <span>(${this.reviewCountFormat(allCount)})</span>
    return `
      <div class="review-header-container">
        <div class="review-header-container-left">
          <p class="review-header-eyebrow-text">${this.$t('parents_talk')}</p>
          <div class="review-header-info">
            <h2 class="star-level-title">
              <span class="pc-shell">${this.$t('what_parents_keep_telling_us')}</span>
              <span class="h5-shell">${allCount > 1 ? this.$t('reviews') : this.$t('review')}</span>
            </h2>
            <div class="review-header-info-h5">
              <span class="review-header-info-star"></span>
              <span class="review-header-info-level">${Number(starLevel).toFixed(1)}</span>
              <span class="review-header-info-count">(${allCount})</span>
            </div>
          </div>
        </div>
        <div class="review-header-container-right">
          ${this.renderReviewStar(starLevel)}
          <div class="review-count">
            <div class="levle">
              ${ Number(starLevel).toFixed(1) }
            </div>
            <div class="count">
              ${allCount + ' ' + (allCount > 1 ? this.$t('reviews') : this.$t('review'))}
            </div>
          </div>
        </div>
      </div>
    `
  }
  renderFilter () {
    const res = this.filters
    if (!res) {
      return ''
    }
    const sort = [{
      key: sortTypeKey,
      name: this.$t('sort_by'),
      values: res.sortTypeVOList.map(item => {
        return {
          key: item.sortType,
          value: item.sortTypeName
        }
      })
    }]
    const filters = sort.concat(res.filterVOList.map(item => {
      item.values = item.filterValueVOList
      item.values.unshift({
        key: 'default',
        value: this.$t('all')
      })
      return item
    }))
    const filtersOptionsContent = filters.reduce((str, option) => {
      return str += this.renderFiltersOptionsItem(option)
    }, '')
    let defaultPicture = 'default'
    if (this.filterResult.picture) {
      defaultPicture = this.filterResult.picture
    }
    const imageFilter = res.filterVOList.find(item => item.key === 'picture')
    let imagesTitle = 'Picture'
    if (imageFilter) {
      imagesTitle = imageFilter.name
    }
    return `
      <div class="review-filter-container-h5 h5-review-shell" data-h5-review-filter>
        <button class="filter-sort-open" data-filter-sort-open>
          ${this.$t('filter')} & ${this.$t('sort')}
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 28 28" width="20" height="20" role="presentation" class="svg-color-fill" style="--fill-color: #646464;" aria-hidden="true">
            <path fill="#1A1A1A" d="M8.95 11.8a2.3 2.3 0 1 1 0-4.6 2.3 2.3 0 0 1 0 4.6Zm-3.5-2.3a3.5 3.5 0 1 0 7 0 3.5 3.5 0 0 0-7 0ZM19.05 20.8a2.3 2.3 0 1 1 0-4.6 2.3 2.3 0 0 1 0 4.6Zm-3.5-2.3a3.5 3.5 0 1 0 7 0 3.5 3.5 0 0 0-7 0Z" clip-rule="evenodd" fill-rule="evenodd" data-follow-fill="#1A1A1A"></path>
            <path fill="#1A1A1A" d="M11.35 8.9h11.2v1.2h-11.2V8.9ZM5.45 17.9h11.2v1.2H5.45v-1.2Z" clip-rule="evenodd" fill-rule="evenodd" data-follow-fill="#1A1A1A"></path>
          </svg>
        </button>
        <div class="review-h5-counts"><span data-filter-all-count>${this.totalCount}</span> ${this.$t('reviews')}</div>
      </div>
      <div data-review-filter-popup class="review-filter-popup">
        <div data-review-filter-close class="review-filter-overlay h5-review-shell">
        </div>
        <div class="review-filter-body">
          <div class="review-filter-body-head h5-review-shell">
            <button data-review-filter-close class="close-popup-review-filter">
              <svg data-v-03aa3c72="" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 28 28" width="32" height="32" role="presentation" class="svg-color-fill" color="#1A1A1A" style="--fill-color: #1A1A1A;" aria-hidden="true"><path fill="#1A1A1A" d="M20.081 19.233 8.767 7.919l-.848.848 11.314 11.314.848-.848Z" data-follow-fill="#1A1A1A"></path><path fill="#1A1A1A" d="M8.767 20.081 20.081 8.768l-.848-.849L7.919 19.233l.848.848Z" data-follow-fill="#1A1A1A"></path></svg>
            </button>
            <div class="divh3">
             ${this.$t('filter')} & ${this.$t('sort')}
            </div>
          </div>
          <form data-filter-form class="review-filter-container" data-pc-review-filter>
            <div class="review-filter-images-head h5-review-shell">
              ${imagesTitle || 'Picture'}
            </div>
            <div class="review-filter-images">
              <div class="review-filter-tab review-filter-options-value" data-filter-item  data-filter-value="all">
                <input type="radio" id="all_reviews" ${defaultPicture === 'default' ? 'checked' : ''} name="picture" value="default">
                <label for="all_reviews">
                  <span class="h5-review-shell h5-checkbox-svg">
                    <svg class="checked" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 28 28" width="24" height="24" role="presentation" class="svg-color-fill" color="#1A1A1A" data-v-5acd2db6="" style="--fill-color: #1A1A1A;" aria-hidden="true"><path fill="#1A1A1A" d="M14 7.5a6.5 6.5 0 1 1 0 13 6.5 6.5 0 0 1 0-13Z" data-follow-fill="#1A1A1A"></path><path fill="#1A1A1A" d="M14 22.3a8.3 8.3 0 1 1 0-16.6 8.3 8.3 0 0 1 0 16.6ZM4.5 14a9.5 9.5 0 1 0 19 0 9.5 9.5 0 0 0-19 0Z" clip-rule="evenodd" fill-rule="evenodd" data-follow-fill="#1A1A1A"></path></svg>
                    <svg class="unchecked" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 28 28" width="24" height="24" role="presentation" class="svg-color-fill" color="#1A1A1A" data-v-5acd2db6="" style="--fill-color: #1A1A1A;" aria-hidden="true"><path fill="#1A1A1A" d="M14 22.3a8.3 8.3 0 1 1 0-16.6 8.3 8.3 0 0 1 0 16.6ZM4.5 14a9.5 9.5 0 1 0 19 0 9.5 9.5 0 0 0-19 0Z" clip-rule="evenodd" fill-rule="evenodd" data-follow-fill="#1A1A1A"></path></svg>
                  </span>
                  ${this.$t('all_reviews')} <span class="pc-review-shell">(</span><span class="pc-review-shell" data-filter-all-count>${this.totalCount}</span><span class="pc-review-shell">)</span>
                </label>
              </div>
              <div class="review-filter-tab review-filter-options-value" data-filter-image-wrap-count="${this.imageCount}" data-filter-item>
                <input type="radio" id="picture_reviews" ${defaultPicture === 'with picture' ? 'checked' : ''} name="picture" value="with picture">
                <label for="picture_reviews">
                  <span class="h5-review-shell h5-checkbox-svg">
                    <svg class="checked" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 28 28" width="24" height="24" role="presentation" class="svg-color-fill" color="#1A1A1A" data-v-5acd2db6="" style="--fill-color: #1A1A1A;" aria-hidden="true"><path fill="#1A1A1A" d="M14 7.5a6.5 6.5 0 1 1 0 13 6.5 6.5 0 0 1 0-13Z" data-follow-fill="#1A1A1A"></path><path fill="#1A1A1A" d="M14 22.3a8.3 8.3 0 1 1 0-16.6 8.3 8.3 0 0 1 0 16.6ZM4.5 14a9.5 9.5 0 1 0 19 0 9.5 9.5 0 0 0-19 0Z" clip-rule="evenodd" fill-rule="evenodd" data-follow-fill="#1A1A1A"></path></svg>
                    <svg class="unchecked" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 28 28" width="24" height="24" role="presentation" class="svg-color-fill" color="#1A1A1A" data-v-5acd2db6="" style="--fill-color: #1A1A1A;" aria-hidden="true"><path fill="#1A1A1A" d="M14 22.3a8.3 8.3 0 1 1 0-16.6 8.3 8.3 0 0 1 0 16.6ZM4.5 14a9.5 9.5 0 1 0 19 0 9.5 9.5 0 0 0-19 0Z" clip-rule="evenodd" fill-rule="evenodd" data-follow-fill="#1A1A1A"></path></svg>
                  </span>
                ${this.$t('images')} <span class="pc-review-shell">(</span><span class="pc-review-shell" data-filter-image-count>${this.imageCount}</span><span class="pc-review-shell">)</span>
                </label>
              </div>
            </div>
            <div class="review-filter-options">
              ${filtersOptionsContent}
            </div>
          </form>
          <div class="review-filter-footer h5-review-shell">
            <button class="review-filter-footer-reset" data-review-filter-clear>
              ${this.$t('reset')}
            </button>
            <button data-review-filter-close class="review-filter-footer-apply">
              ${this.$t('apply')} (<span data-filter-image-count>${this.totalCount}</span>)
            </button>
          </div>
        </div>
      </div>
    `
  }

  renderFiltersOptionsItem (option) {
    const supportFilter = ['rating', sortTypeKey]
    if (!supportFilter.includes(option.key)) {
      return ''
    }
    // const starSvg = `
    //  <svg class="star-icon" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 28 28" width="20" height="20" role="presentation" class="svg-color-fill" data-v-5acd2db6="" style="--fill-color: #1A1A1A;" aria-hidden="true"><path fill="#1A1A1A" d="m14 5.897 2.675 5.42 5.982.87-4.328 4.22 1.022 5.957L14 19.551 8.65 22.364l1.022-5.957-4.33-4.22 5.983-.87L14 5.898Z" clip-rule="evenodd" fill-rule="evenodd" data-follow-fill="#1A1A1A"></path><path fill="#1A1A1A" d="m14 4.542 3.074 6.228 6.873.998-4.973 4.848 1.174 6.845L14 20.23l-6.147 3.232 1.174-6.845-4.974-4.848 6.873-.998L14 4.542Zm0 2.711-2.277 4.613-5.09.74 3.683 3.591-.87 5.07L14 18.875l4.554 2.394-.87-5.071 3.684-3.59-5.091-.74L14 7.252Z" clip-rule="evenodd" fill-rule="evenodd" data-follow-fill="#1A1A1A"></path></svg>
    // `
    const liContent = option.values.reduce((str, item) => {
      const id = option.key + '_' + item.key
      let defaultChecked = 'default'
      if (this.filterResult[option.key]) {
        defaultChecked = this.filterResult[option.key]
      }
      // if (option.key === 'rating') {
      //   return str + `
      //     <li class="review-filter-options-value">
      //       <input type="radio" id="${id}" ${defaultChecked === item.key ? 'checked' : ''} name="${option.key}" value="${item.key}">
      //       <label for="${id}">
      //         <span class="h5-review-shell h5-checkbox-svg">
      //           <svg class="checked" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 28 28" width="24" height="24" role="presentation" class="svg-color-fill" color="#1A1A1A" data-v-5acd2db6="" style="--fill-color: #1A1A1A;" aria-hidden="true"><path fill="#1A1A1A" d="M14 7.5a6.5 6.5 0 1 1 0 13 6.5 6.5 0 0 1 0-13Z" data-follow-fill="#1A1A1A"></path><path fill="#1A1A1A" d="M14 22.3a8.3 8.3 0 1 1 0-16.6 8.3 8.3 0 0 1 0 16.6ZM4.5 14a9.5 9.5 0 1 0 19 0 9.5 9.5 0 0 0-19 0Z" clip-rule="evenodd" fill-rule="evenodd" data-follow-fill="#1A1A1A"></path></svg>
      //           <svg class="unchecked" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 28 28" width="24" height="24" role="presentation" class="svg-color-fill" color="#1A1A1A" data-v-5acd2db6="" style="--fill-color: #1A1A1A;" aria-hidden="true"><path fill="#1A1A1A" d="M14 22.3a8.3 8.3 0 1 1 0-16.6 8.3 8.3 0 0 1 0 16.6ZM4.5 14a9.5 9.5 0 1 0 19 0 9.5 9.5 0 0 0-19 0Z" clip-rule="evenodd" fill-rule="evenodd" data-follow-fill="#1A1A1A"></path></svg>
      //         </span>
      //         ${item.key === 'default' ? item.value : item.value + starSvg}
      //       </label>
      //     </li>
      //   `
      // }
      return str + `
        <li class="review-filter-options-value">
          <input type="radio" id="${id}" ${(defaultChecked === item.key || item.key === 0) ? 'checked' : ''} name="${option.key}" value="${item.key}">
            <label for="${id}">
              <span class="h5-review-shell h5-checkbox-svg">
                <svg class="checked" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 28 28" width="24" height="24" role="presentation" class="svg-color-fill" color="#1A1A1A" data-v-5acd2db6="" style="--fill-color: #1A1A1A;" aria-hidden="true"><path fill="#1A1A1A" d="M14 7.5a6.5 6.5 0 1 1 0 13 6.5 6.5 0 0 1 0-13Z" data-follow-fill="#1A1A1A"></path><path fill="#1A1A1A" d="M14 22.3a8.3 8.3 0 1 1 0-16.6 8.3 8.3 0 0 1 0 16.6ZM4.5 14a9.5 9.5 0 1 0 19 0 9.5 9.5 0 0 0-19 0Z" clip-rule="evenodd" fill-rule="evenodd" data-follow-fill="#1A1A1A"></path></svg>
                <svg class="unchecked" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 28 28" width="24" height="24" role="presentation" class="svg-color-fill" color="#1A1A1A" data-v-5acd2db6="" style="--fill-color: #1A1A1A;" aria-hidden="true"><path fill="#1A1A1A" d="M14 22.3a8.3 8.3 0 1 1 0-16.6 8.3 8.3 0 0 1 0 16.6ZM4.5 14a9.5 9.5 0 1 0 19 0 9.5 9.5 0 0 0-19 0Z" clip-rule="evenodd" fill-rule="evenodd" data-follow-fill="#1A1A1A"></path></svg>
              </span>
              ${item.value}
            </label>
        </li>
      `
    }, '')
    return `
      <div class="review-filter-options-item">
        <button class="filter-options-button">
          <span data-key-value="${option.key}">
           ${option.name}
          </span>
          ${this.renderArrowSvg()}
        </button>
        <ul class="review-filter-options-picker">
          ${liContent}
        </ul>
      </div>
    `
  }

  updataFilter () {
    const filterEl = this.dom.querySelector('[data-review-filter]')
    if (filterEl) {
      const filterContent = this.renderFilter()
      filterEl.innerHTML = filterContent
      setTimeout(() => {
        const formArr = [...filterEl.querySelectorAll('form')]
          formArr.forEach(form => {
            form.addEventListener('submit', (e)=> {
              e.preventDefault();
            })
          })
          this.initReviewPopup()
          this.addFilterEvent()
      }, 1000);
    }
  }

  addFilterEvent () {
    const _this = this
    const clearBtnArr = [...this.dom.querySelectorAll('[data-review-filter-clear]')]
    clearBtnArr.forEach(item => {
      item.addEventListener('click', () => {
        _this.clearForm()
      })
    })
    const inputs = [...this.dom.querySelectorAll('input')]
    const changehandle = this.throttle(this.changeEvent.bind(this), 600)
    inputs.forEach(item => {
      item.addEventListener('change', () => {
        this.currentPage = 1
        this.updataPagination()
        // if (item.name === 'picture') {
        //   this.clearForm(true)
        //   item.checked = true
        // }
        changehandle()
      })
    })
  }

  changeEvent () {
    const formEl = this.dom.querySelector('[data-filter-form]')
    if (formEl) {
      const formData = new FormData(formEl);
      // 转为普通对象
      const data = Object.fromEntries(formData.entries());
      const params = {}
      for(let key in data) {
        if (data[key] !== 'default') {
          if (key === 'picture') {
            params.withMedias = true
          } else {
            params[key] = data[key]
          }
        }
      }
      openLoading()
      // console.log('change----', params)
      this.fetchReviewList(params).then(reviewRes => {
        if (reviewRes) {
          if (!params.withMedias) {
            this.totalCount = reviewRes.total
          }
          this.imageCount = reviewRes.withMediasTotal
          this.reviewList = reviewRes.productReviewVOList
          this.currentTotal = reviewRes.total
          this.updataReviewCount()
          this.updataReviewList()
          this.updataPagination()
        }
      }).finally(() => {
        closeLoading()
      })
    }
  }

  clearForm (notRequest = false) {
    const formEl = this.dom.querySelector('[data-filter-form]')
    if (formEl) {
      const defaultInput = [...formEl.querySelectorAll('input[value="default"]'), ...formEl.querySelectorAll('input[value="0"]')]
      let hasNotDefault = false
      defaultInput.forEach(item => {
        if (!item.checked) {
          hasNotDefault = true
        }
        item.checked = true
      })
      if (hasNotDefault && !notRequest) {
        setTimeout(() => {
          this.changeEvent()
        }, 50)
      }
    }
  }

  renderReviewItemOptions (review) {
    const optionsMap = []
    if (review.color) {
      optionsMap.push({
        key: 'Color',
        value: review.color
      })
    }
    if (review.size) {
      optionsMap.push({
        key: 'Size',
        value: review.size
      })
    }
    // if (review.option) {
    //   const option = review.option || {}
    //   for (const key in option) {
    //     optionsMap.push({
    //       key: key,
    //       value: option[key]
    //     })
    //   }
    //   const size = review.size || []
    //   size.forEach(el => {
    //     let elArr = el.split(':')
    //     if (elArr.length === 1) {
    //       elArr = el.split('：')
    //     }
    //     if (elArr.length === 2) {
    //       optionsMap.push({
    //         key: elArr[0],
    //         value: elArr[1]
    //       })
    //     }
    //   })
    // }
    let reviewItemOptionsContent = optionsMap.reduce((str, item) => {
      return str + `
        <span class="review-item-options-key">
          <span class="patpat-NewBold">${ item.key }</span>: ${ item.value }
        </span>
      `
    }, '')
    return `
      <div class="review-item-options">
       ${reviewItemOptionsContent}
      </div>
    `
  }

  renderReviewImages (review) {
    if (review.mediaVOList && review.mediaVOList.length > 0) {
      const imgContent = review.mediaVOList.reduce((str, item) => {
        if (item.smallUrl) {
        const src = item.url
        const attr = `data-pswp-src="${src}" data-pswp-width="600" data-pswp-height="800" data-pswp-style="style1"`
        return str + `
          <div class="pswp-item">
            ${this.renderImg(item.smallUrl, '', '250x0', 'reviews')}
            <a aria-hidden="true" href="${src}" ${attr}></a>
          </div>
        `
        } else {
          return str
        }
      }, '')
      return `
        <div class="img-list not-scrollbar" data-review-imgs>
          ${imgContent}
        </div>
      `
    }
    return ''
  }

  renderReviewItem (item) {
    const reviewTime = this.reviewTimeFormat(item)
    let reviewTitleContent = ''
    if (item.title) {
      reviewTitleContent = `<p class="review-title">${item.title}</p>`
    }
    const reviewContent = `<p class="review-content">${item.content || ''}</p>`

    let reviewItemAvatarContent = `<div class="avatar-txt patpat-NewBold"> ${item.reviewerDisplayName[0]} </div>`
    if (item.avatar) {
      reviewItemAvatarContent =  this.renderImg(item.avatar, 'avatar-icon', '50x0', item.reviewerDisplayName)
    }
    if (item.variantImageUrl ) {
      reviewItemAvatarContent =  this.renderImg(item.avatar, 'avatar-icon', '50x0', item.reviewerDisplayName)
    }
    if (item.variantImageUrl ) {
      const variantImageUrl = item.variantImageUrl + '&width=150'
      reviewItemAvatarContent =  this.renderImg(variantImageUrl, 'avatar-icon', '50x0', item.reviewerDisplayName)
    }

    if (item.shopifyVariantUrl) {
      reviewItemAvatarContent = `<a class="avatar-wrap" href="${item.shopifyVariantUrl}">${reviewItemAvatarContent}</a>`
    } else {
      reviewItemAvatarContent = `<div class="avatar-wrap">${reviewItemAvatarContent}</div>`
    }
    return `
      <div class="reviews-list-item">
        <div>
          ${this.renderReviewStar(item.rating)}
          ${reviewTitleContent + reviewContent}
        </div>
        <div class="review-user">
          <div>
            <p class="review-name"> ${item.reviewerDisplayName}</p>
            <span class="review-time">${reviewTime}</span>
          </div>
          ${reviewItemAvatarContent}
        </div>
      </div>
    `
  }

  renderReviewList(reviewList = []) {
    if (reviewList.length > 0) {
      let reviewListContent = reviewList.reduce((str, item) => {
        return str += this.renderReviewItem(item)
      }, '')
      return reviewListContent !== '' ? reviewListContent + '<div class="review-list-empty"></div>' : ''
    } else {
      return this.renderEmpty(true)
    }
  }

  updataReviewList () {
    const reviewList = this.reviewList
    const reviewListWrap = this.dom.querySelector('[data-review-list]')
    if (reviewListWrap) {
      const reviewListEl = this.renderReviewList(reviewList)
      reviewListWrap.innerHTML = reviewListEl
      setTimeout(() => {
        this.addEventLightbox()
        this.initHorizationScrollWrap()
      }, 50);
    }
  }

  initHorizationScrollWrap () {
    const throttle = (func, limit = 16) => {
      let timer = null
      let lastArgs
      let lastThis

      return function (...args) {
        lastArgs = args
        lastThis = this

        if (!timer) {
          timer = setTimeout(() => {
            func.apply(lastThis, lastArgs)
            timer = null
          }, limit)
        }
      }
    }

    const startHorizationScrollWrap = (el) => {
      const controlsEl = el.nextElementSibling && el.nextElementSibling.matches('[data-review-scroll-controls]')
        ? el.nextElementSibling
        : this.dom.querySelector('[data-review-scroll-controls]')
      const prevBtnEl = controlsEl ? controlsEl.querySelector('.review-horization-scroll-prve') : null
      const nextBtnEl = controlsEl ? controlsEl.querySelector('.review-horization-scroll-next') : null
      const scrollEl = el.querySelector('[data-review-scroll]')

      if (!scrollEl) {
        return
      }

      const scheduleCheckPrevNextButton = () => {
        requestAnimationFrame(() => {
          checkPrevNextButton()
          setTimeout(checkPrevNextButton, 300)
        })
      }

      const checkPrevNextButton = () => {
        if (!(prevBtnEl && nextBtnEl)) {
          return
        }

        controlsEl && controlsEl.classList.remove('show')
        prevBtnEl.classList.remove('show')
        nextBtnEl.classList.remove('show')
        prevBtnEl.disabled = false
        nextBtnEl.disabled = false

        const scrollableDistance = scrollEl.scrollWidth - scrollEl.clientWidth
        if (scrollableDistance <= 10) {
          prevBtnEl.disabled = true
          nextBtnEl.disabled = true
          return
        }

        const currentScrollLeft = scrollEl.scrollLeft
        controlsEl && controlsEl.classList.add('show')
        prevBtnEl.classList.add('show')
        nextBtnEl.classList.add('show')

        prevBtnEl.disabled = currentScrollLeft <= 10
        nextBtnEl.disabled = currentScrollLeft > scrollableDistance - 10
      }

      if (el.dataset.reviewHorizationScrollReady !== 'true') {
        if (prevBtnEl) {
          prevBtnEl.addEventListener('click', () => {
            scrollEl.scrollTo({
              left: scrollEl.scrollLeft - scrollEl.clientWidth,
              behavior: 'smooth'
            })
          })
        }

        if (nextBtnEl) {
          nextBtnEl.addEventListener('click', () => {
            scrollEl.scrollTo({
              left: scrollEl.scrollLeft + scrollEl.clientWidth,
              behavior: 'smooth'
            })
          })
        }

        scrollEl.addEventListener('scroll', throttle(checkPrevNextButton))
        window.addEventListener('resize', throttle(scheduleCheckPrevNextButton, 100))
        el.dataset.reviewHorizationScrollReady = 'true'
      }

      scheduleCheckPrevNextButton()
    }

    const horizationScrollWrapArr = [...this.dom.querySelectorAll('[data-horization-wraper]')]
    horizationScrollWrapArr.forEach(item => {
      startHorizationScrollWrap(item)
    })
  }

  updataReviewCount () {
    // 更新评论数量
    const allCount = [...this.dom.querySelectorAll('[data-filter-all-count]')]
    allCount.forEach(item => {
      item.innerHTML = this.totalCount
    })
    const imageCount = [...this.dom.querySelectorAll('[data-filter-image-count]')]
    imageCount.forEach(item => {
      item.innerHTML = this.imageCount
    })
    const imageWrapEl = this.dom.querySelector('[data-filter-image-wrap-count]')
    if (imageWrapEl) {
      imageWrapEl.setAttribute('data-filter-image-wrap-count', this.imageCount)
    }
  }
  addEventLightbox () {
    const _this = this
    if (_this.currentLightbox) {
      _this.currentLightbox.destroy()
    }
    const {
      icons: icons$1
    } = window.theme;
    import(flu.chunks.photoswipe).then(_ref => {
      let {
        PhotoSwipeLightbox,
        PhotoSwipe
      } = _ref;
      _this.currentLightbox = new PhotoSwipeLightbox({
        gallery: '[data-review-imgs]',
        children: '.pswp-item', // 直接选择 img 元素
        showHideAnimationType: "zoom",
        pswpModule: PhotoSwipe,
        mainClass: "pswp--product-lightbox",
        bgOpacity: 1,
        arrowPrevSVG: icons$1.chevron,
        arrowNextSVG: icons$1.chevron,
        closeSVG: icons$1.close,
        zoomSVG: icons$1.zoom
      });
      _this.currentLightbox.init();
      _this.currentLightbox.on('contentActivate', (e) => {
        // 特殊处理
        if (e.content.placeholder && e.content.placeholder.element) {
          e.content.placeholder.element.classList.add('review-placeholder');
        }
      });
    })
  }

  renderArrowSvg () {
    return `
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 28 28" width="16" height="16" role="presentation" color="#1A1A1A" aria-hidden="true">
        <path fill="#1A1A1A" d="m10.151 7 7.072 7.071-7.072 7.071.849.849 7.92-7.92L11 6.151 10.151 7Z" clip-rule="evenodd" fill-rule="evenodd" data-follow-fill="#1A1A1A"></path>
      </svg>
    `
  }

  renderPagination () {
    const page = Math.ceil(this.currentTotal / this.pageCount)
    if (page > 1) {
      const list = []
      const half = parseInt(this.pagegroup / 2)
      if (page > this.pagegroup) {
        if (this.currentPage < half + 1) {
          for (let i = 0; i < this.pagegroup; i++) {
            list.push({ text: i + 1, val: i + 1 })
          }
        } else if (this.currentPage > page - half) {
          for (let i = page - this.pagegroup; i < page; i++) {
            list.push({ text: i + 1, val: i + 1 })
          }
        } else {
          for (let i = this.currentPage - half - 1; i < this.currentPage + half; i++) {
            if (i + 1 <= page) {
              list.push({ text: i + 1, val: i + 1 })
            }
          }
        }
      } else {
        for (let i = 1; i <= page; i++) {
          list.push({ text: i, val: i })
        }
      }
      const navContent = list.reduce((str, item) => {
        let className = 'review-nav-item'
        if (item.val === this.currentPage) {
          className += ' active'
        }
        return str + `
          <button class="${className}" data-index="${item.val}" data-review-nav>
           ${item.text}
          </button>
        `
      }, '')
      let reviewPrveClass = ''
      let reviewNextClass = ''
      if (this.currentPage === 1) {
        reviewPrveClass = 'disable'
      }
      if (this.currentPage === page) {
        reviewNextClass = 'disable'
      }
      return `
      <div class="reviews-pagination">
        <div class="total-pages">
        ${this.$t('total_pages', {page: page})}
        </div>
        <nav class="review-nav">
          <button class="review-prve ${reviewPrveClass}" data-review-prve>
            ${this.renderArrowSvg()}
          </button>
          ${navContent}
          <button class="review-next ${reviewNextClass}" data-review-next>
            ${this.renderArrowSvg()}
          </button>
        </nav>
      </div>
      `
    }
    return ''
  }

  updataPagination () {
    const paginationWrapEl = this.dom.querySelector('[data-review-pagination]')
    if (paginationWrapEl) {
      const content = this.renderPagination()
      paginationWrapEl.innerHTML = content
      setTimeout(() => {
        this.paginationAddEvent(paginationWrapEl)
      }, 30)
    }
  }

  paginationAddEvent () {
    const navsEl = [...this.dom.querySelectorAll('[data-review-nav]')]
    const prveEl = this.dom.querySelector('[data-review-prve]')
    const nextEl = this.dom.querySelector('[data-review-next]')
    if (navsEl && prveEl && nextEl) {
      const updataCurrentPage = () => {
        this.changeEvent()
        this.updataPagination()
      }
      const navBtnClick = (target) => {
        const idx = Number(target.getAttribute('data-index'))
        if (idx === this.currentPage) {
          return
        }
        this.currentPage = idx
        updataCurrentPage()
      }
      navsEl.forEach(item => {
        item.addEventListener('click', function () {
          navBtnClick(item)
        })
      })
      prveEl.addEventListener('click', () => {
        if (this.currentPage === 1) {
          return
        } else {
          this.currentPage -= 1
          updataCurrentPage()
        }
      })
      nextEl.addEventListener('click', () => {
        const page = Math.ceil(this.totalCount / this.pageCount)
        if (this.currentPage === page) {
          return
        } else {
          this.currentPage += 1
          updataCurrentPage()
        }
      })
    }
  }


  render () {
    if (this.totalAll > 0) {
      this.dom.innerHTML = `
        ${this.renderHeader(this.avgRating, this.sizePercent, this.totalAll)}
        <div class="review-horization-scroll-wraper not-scrollbar" data-horization-wraper>
          <div class="review-horization-scroll not-scrollbar" data-review-scroll>
            <div class="review-list" data-review-list>
            </div>
          </div>
        </div>
        <div class="review-carousel-controls pc-shell" data-review-scroll-controls>
          <button class="review-horization-scroll-prve" type="button" aria-label="Previous reviews">
            <svg width="24" height="24" viewBox="0 0 24 24" aria-hidden="true" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path th d="M5 11.7429H19.1421M13.3992 6L19.1444 11.7452L13.3992 17.4905" stroke="#000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
            </svg>
          </button>
          <button class="review-horization-scroll-next" type="button" aria-label="Next reviews">
            <svg width="24" height="24" viewBox="0 0 24 24" aria-hidden="true" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path th d="M5 11.7429H19.1421M13.3992 6L19.1444 11.7452L13.3992 17.4905" stroke="#000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
            </svg>
          </button>
        </div>
      `
      setTimeout(() => {
        // this.updataFilter()
        this.updataReviewList()
        // // this.updataReviewList([testReview, testReview, testReview])
        // this.updataPagination()
      }, 30)
    } else {
      this.dom.style.display = 'none'
      // this.dom.innerHTML = this.renderEmpty()
    }
  }
  renderEmpty (ishiddenTitle = false) {
    let title = `<h2>
      ${this.$t('reviews')}
      </h2>`
    if (ishiddenTitle) {
       title = ''
    }
    return `
    <div class="review-empty">
      ${title}
      <div class="review-empty-content">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 128 128" width="128" height="128" role="presentation" class=""><path d="M48.7002 60.5V97.1H82.8002L92.9002 107.2V97.1H100.9V60.5H48.7002Z" stroke="#353839" stroke-width="1.3" stroke-miterlimit="10"></path><path d="M48.7001 75.0004H45.4001L35.2001 85.1004V75.0004H27.1001V38.4004H78.5001V60.5004H48.7001V75.0004Z" fill="#353839"></path><path d="M60.3003 69.7012H78.5003" stroke="#353839" stroke-width="1.3" stroke-miterlimit="10"></path><path d="M60.3003 78.8008H89.3003" stroke="#353839" stroke-width="1.3" stroke-miterlimit="10"></path><path d="M60.3003 87.9004H69.7003" stroke="#353839" stroke-width="1.3" stroke-miterlimit="10"></path><path d="M38.3003 47.5H70.4003" stroke="white" stroke-width="1.3" stroke-miterlimit="10"></path><path d="M38.3003 65.8008H43.9003" stroke="white" stroke-width="1.3" stroke-miterlimit="10"></path><path d="M38.3003 56.5996H55.1003" stroke="white" stroke-width="1.3" stroke-miterlimit="10"></path><path d="M11.7002 108H20.1002" stroke="#353839" stroke-width="1.3" stroke-miterlimit="10"></path><path d="M107.9 108H116.3" stroke="#353839" stroke-width="1.3" stroke-miterlimit="10"></path><path d="M26.5 108H101.5" stroke="#353839" stroke-width="1.3" stroke-miterlimit="10"></path><path d="M20.8001 93.0992C21.4628 93.0992 22.0001 92.562 22.0001 91.8992C22.0001 91.2365 21.4628 90.6992 20.8001 90.6992C20.1374 90.6992 19.6001 91.2365 19.6001 91.8992C19.6001 92.562 20.1374 93.0992 20.8001 93.0992Z" fill="#353839"></path><path d="M27.3001 96.4996C28.5151 96.4996 29.5001 95.5146 29.5001 94.2996C29.5001 93.0846 28.5151 92.0996 27.3001 92.0996C26.0851 92.0996 25.1001 93.0846 25.1001 94.2996C25.1001 95.5146 26.0851 96.4996 27.3001 96.4996Z" fill="#353839"></path><path d="M95.6006 41.2L104.801 32" stroke="#353839" stroke-width="1.3" stroke-miterlimit="10"></path><path d="M97.3003 45.3008L104.8 43.3008" stroke="#353839" stroke-width="1.3" stroke-miterlimit="10"></path><path d="M91.4004 39.5L93.5004 32" stroke="#353839" stroke-width="1.3" stroke-miterlimit="10"></path></svg>
        <p> Be the first to review our newest products – make a purchase now! </p>
      </div>
    </div>
    `
  }

  initReviewPopup () {
    const el = this.dom.querySelector('[data-review-filter-popup]')
    const openEl = this.dom.querySelector('[data-filter-sort-open]')
    if (el) {
      const overlayEl = el.querySelector('.review-filter-overlay')
      const closePopupArrEl = [...el.querySelectorAll('[data-review-filter-close]')]
      closePopupArrEl.forEach(item => {
        item.addEventListener('click', closePopup)
      })
      let lastScrollTop = document.body.scrollTop || document.documentElement.scrollTop
      // el.removeAttribute('data-h5-review-filter')
      function closePopup () {
        document.body.style.overflow = ''
        if (document.documentElement) {
          document.documentElement.scrollTop = lastScrollTop
        }
        if (document.body) {
          document.body.scrollTop = lastScrollTop
        }
        document.body.style.top = ''
        el.classList.remove('show')
        function animationendEvent () {
          el.classList.remove('appear')
          overlayEl.removeEventListener('animationend', animationendEvent)
        }
        overlayEl.addEventListener('animationend', animationendEvent)
      }
      function openPopup () {
        el.classList.add('show')
        el.classList.add('appear')
        document.body.style.overflow = 'hidden'
        lastScrollTop = document.body.scrollTop || document.documentElement.scrollTop
        document.body.style.top = -lastScrollTop + 'px'
      }
      if (openEl) {
        openEl.addEventListener('click', openPopup)
      }
      const viewportWidth = window.visualViewport?.width || document.documentElement.clientWidth || window.innerWidth;
      let isH5 = viewportWidth < 1028
      window.addEventListener('resize', () => {
        if (viewportWidth < 1028) {
          isH5 = true
        } else {
          if (isH5) {
            closePopup()
          }
          isH5 = false
        }
      })
    }
  }
}
function handleHttpsUrl (url) {
  if (/^http:\/\//i.test(url)) {
    url = url.replace(/^http:\/\//, '//');
  }
  if (!/^https:\/\//i.test(url)) {
    url = 'https:' + url;
  }
  return url
}
const handleProductStructDataString = (reviews, ratingValue, reviewCount, empty) => {
  const reviewCariantsEl = document.querySelector('[data-review-variants]')
  const productInfoEl = document.querySelector('[data-review-product-info]')
  let name = ''
  let url = ''
  let description = ''
  let price = '$99'
  if (productInfoEl) {
    description = productInfoEl.textContent
    name = productInfoEl.getAttribute('data-name')
    url = productInfoEl.getAttribute('data-url')
    price = productInfoEl.getAttribute('data-price')
  }
  // const images = []
  // if (reviewCariantsEl) {
  //   try {
  //     const reviewCariants = JSON.parse(reviewCariantsEl.textContent)
  //     reviewCariants.forEach(item => {
  //       images.push({
  //         '@type': 'ImageObject',
  //         contentUrl: handleHttpsUrl(item.featured_image.src),
  //         name: item.title,
  //         description: item.name,
  //         creator: {
  //           '@type': 'Organization',
  //           name: 'PatPat',
  //           url: 'https://www.patpat.com'
  //         },
  //         copyrightHolder: {
  //           '@type': 'Organization',
  //           name: 'PatPat',
  //           url: 'https://www.patpat.com'
  //         }
  //       })
  //     })
  //     images = reviewCariants.map((item) => {
  //       return {
  //         '@type': 'ImageObject',
  //         contentUrl: item.image,
  //         name: item.name,
  //         description: item.description,
  //         creator: {
  //           '@type': 'Organization',
  //           name: 'PatPat',
  //           url: 'https://www.patpat.com'
  //         },
  //         copyrightHolder: {
  //           '@type': 'Organization',
  //           name: 'PatPat',
  //           url: 'https://www.patpat.com'
  //         }
  //       }
  //     })

  //   } catch {
  //     console.log('data-review-variants to JSON error')
  //   }
  // }
  const review = reviews.map((item) => {
    return {
      '@type': 'Review',
      author: { type: 'Person', name: item.reviewerDisplayName || 'PatPat' },
      reviewBody: item.content,
      reviewRating: {
        '@type': 'Rating',
        ratingValue: (item.rating || 5).toFixed(1)
      }
    }
  })
  const aggregateRating = {
    "@type": "AggregateRating",
    "ratingValue": ratingValue,
    // "empty": empty,
    "reviewCount": reviewCount || 1
  }
  const data = {
    "@context": "https://schema.org",
    "@type": "Product",
    "name": name,
    "description": description,
    // "image": images,
    "url": url,
    "price": price,
    "priceCurrency": window.Shopify.currency.active,
    "aggregateRating": aggregateRating,
    "review": review
  }
  const productLdJsonEl = document.querySelector('[data-product-ld-json]')
  if (productLdJsonEl) {
    if (reviewCount > 0) {
      try {
        const productLdJson = JSON.parse(productLdJsonEl.textContent)
        productLdJson.aggregateRating = aggregateRating
        productLdJson.review = review
        productLdJsonEl.textContent = JSON.stringify(productLdJson)
      } catch {
        console.log('data-product-ld-json to JSON error')
      }
    }
  } else {
    const script = document.createElement('script')
    script.type = 'application/ld+json'
    script.innerText = JSON.stringify(data)
    document.head.appendChild(script)
  }

}
new ProductReview({
  el: '#review-module'
})
